<template>
  <div class="notify">
    <div  v-for="alert of getAlerts" :key="alert.id">
      <div :class="alert.variant" class="message">{{alert.message}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "no-alert",
  data() {
    return {

    };
  },
  methods: {
    ...mapMutations(["removeAlert"])
  },
  computed: {
    ...mapGetters(["getAlerts"])
  }
};
</script>



<style lang="scss" scoped>
@import '../assets/scss/vars.scss';

.notify {
  position: fixed;
  z-index: 20;
  bottom: 20px;
  width: 100%;
}

.message {
  position: relative;
  width: 550px;
  text-align: center;
  padding: 20px;
  border-radius: 10px;
  background-color: lightgreen;
  border: 2px solid #696969;
  color: #484848;
  font-size: 20px;
  margin: auto;
  box-shadow: 0px 0px 15px #484848;
}

.success {
  background-color: lightgreen;
}

.warn {
  background-color: gold;
}

.error {
  background-color: #ff4f4f;
}

</style>